import TableEditor from "./InvoiceCustomization/pages/table-editor";
function InvoiceCustomization() {
  return (
    <div className="App">
      <TableEditor/>
    </div>
  );
}

export default InvoiceCustomization;
